import { render } from "./TextPage3HS.vue?vue&type=template&id=1598607b"
import script from "./TextPage3HS.vue?vue&type=script&lang=js"
export * from "./TextPage3HS.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\grego\\Documents\\Projets_info\\New-project\\gregoire-aimier-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__